import { MouseEvent, ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';

import { DataTrackerEventData } from 'approot/shared/data-tracker/data-tracker.constants';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import { RoundIconButtonStyled } from './round-icon-button.style';

type Props = {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  selected?: boolean;
  rightSpacing?: boolean;
  bottomSpacing?: boolean;
  noBorder?: boolean;
  isDanger?: boolean;
  isNegative?: boolean;
  // icon
  icon?: ReactNode;
  isPlusIcon?: boolean;
  // ga tracking
  dataEventCategory?: string;
  dataAction?: string; // default data action
  dataActionSelected?: string; // data action if selected=true is passed in
  dataTargetArgs?: DataTrackerEventData;
  isCardButton?: boolean;
  className?: string;
  'aria-label': string; // make build fail if we forget it
} & ButtonHTMLAttributes<HTMLButtonElement>;

const RoundButton = forwardRef(
  (
    {
      onClick,
      selected,
      dataEventCategory,
      dataAction,
      dataActionSelected,
      dataTargetArgs,
      title,
      rightSpacing,
      bottomSpacing,
      noBorder,
      isDanger,
      isNegative,
      icon,
      isPlusIcon,
      isCardButton,
      className,
      ...buttonProps
    }: Props,
    ref
  ) => {
    return (
      <RoundIconButtonStyled
        ref={ref as any}
        title={title}
        onClick={event => {
          event.preventDefault();
          onClick && onClick(event);
          if (dataEventCategory && dataTargetArgs) {
            pushDataTrackerEvent(
              dataEventCategory,
              selected
                ? dataActionSelected || ''
                : dataAction
                  ? dataAction
                  : '',
              dataTargetArgs
            );
          }
        }}
        type="button"
        $selected={!!selected}
        $rightSpacing={rightSpacing}
        $bottomSpacing={bottomSpacing}
        $noBorder={noBorder}
        $isCardButton={isCardButton}
        $isPlusIcon={isPlusIcon}
        $isDanger={isDanger}
        $isNegative={isNegative}
        className={className}
        {...buttonProps}
      >
        {icon}
      </RoundIconButtonStyled>
    );
  }
);

export default RoundButton;
